
import BoxCategoryListComponent from "../../../components/box_categories/Index.vue";

export default {
  components: {
    BoxCategoryListComponent
  }
}
